import React from "react";
import { services, productFamilies } from "@/content/site";
import { PageHero, Section, CtaBand, FeatureCard, CardGrid } from "@/components/NovaKit";

export default function Services() {
  return (
    <div data-testid="services-page">
      <PageHero
        eyebrow={services.eyebrow}
        heading={services.heading}
        highlight="setup, workflow, connectivity, and visibility"
        intro={services.intro}
        index="04"
      />
      <Section eyebrow="Product & service families" heading="The four operating families behind every engagement" highlight="four operating families" body="Depending on the use case, clients engage with Hubinall through setup coordination, workflow software, data connectivity, or insight-oriented modules." indexLabel="04.1" bg="panel">
        <CardGrid cols={2}>
          {productFamilies.map((f, i) => {
            const featured = i === 0 || i === 3;
            return (
              <FeatureCard
                key={f.key}
                index={`FAMILY · 0${i + 1}`}
                pill={`${f.modules.length} modules`}
                title={f.name}
                body={f.summary}
                featured={featured}
                to={"/solutions"}
                footer={
                  <ul className="space-y-3">
                    {f.modules.map((m) => (
                      <li key={m.name} className={"border-t pt-3 " + (featured ? "border-white/20" : "hairline")}>
                        <div className={"mono text-[10.5px] tracking-[0.12em] uppercase font-bold mb-1 " + (featured ? "text-white" : "text-[#0A0E1A]")}>{m.name}</div>
                        <div className={"text-xs leading-relaxed " + (featured ? "text-white/75" : "text-[#0A0E1A]/65")}>{m.desc}</div>
                      </li>
                    ))}
                  </ul>
                }
              />
            );
          })}
        </CardGrid>
      </Section>
      <Section eyebrow={services.deliversHeading} heading="Four operating outcomes, one coordinated path" highlight="one coordinated path" indexLabel="04.2">
        <CardGrid cols={2}>
          {services.delivers.map(([title, body], i) => (
            <FeatureCard key={title} index={`OUTCOME · 0${i + 1}`} title={title} body={body} featured={i === 0 || i === 3} />
          ))}
        </CardGrid>
      </Section>
      <Section eyebrow="What's included" heading="Hubinall covers the full operating sequence" highlight="full operating sequence" indexLabel="04.3">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {productFamilies.map((f) => (
            <div key={f.key} className="grad-border grad-border-on bg-white rounded-[20px] p-8">
              <div className="mono text-[11px] tracking-[0.22em] uppercase grad-text font-bold mb-4">{f.name}</div>
              <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2">
                {f.modules.map((m) => (
                  <li key={m.name} className="text-sm text-[#0A0E1A]/80 flex items-start gap-2">
                    <span className="grad-text font-bold mt-1">+</span>
                    <span>{m.name}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <p className="text-[#0A0E1A]/70 max-w-3xl leading-relaxed text-base md:text-lg mt-12 border-l-4 border-[#4F46E5] pl-5 italic">
          {services.note}
        </p>
      </Section>
      <CtaBand heading="Let's plan your next operational layer." ctas={services.ctas} />
    </div>
  );
}
